import { actionCreatorFactory } from 'typescript-fsa'
import { State } from './reducer'

const actionCreator = actionCreatorFactory()

export const toggleDrawer = actionCreator('toggleDrawer')
export const changeDrawer = actionCreator<Partial<State>>('changeDrawer')
